import { createContext } from 'react';

import { FetchContext } from '../types';

export const DataTableContext = createContext(null as FetchContext | null);
